import { useEffect } from 'react';
import { glideIntoView, glideToTop } from '../../tarot-utils/glide';
import { willNarrate } from '../../voice/ReadingSession';
import { FAN_ROLL_MS, FAN_FOLD_MS } from './useReadingFlow';

// Wait for the new step's entrance to start, so it has its size
const SETTLE_MS = 120;
// Once the last card is picked, the fan rolls shut and folds down, which
// brings the cards up the page; only then is it known where they are
const LAST_PICK_MS = FAN_ROLL_MS + FAN_FOLD_MS + 100;

/**
 * The one place the reading flow scrolls the page: each time it reaches a
 * new step, the view glides down to it.
 *
 * `steps` maps each phase to a ref on its FlowStep.
 */
export function useFlowScroll(phase, steps) {
  useEffect(() => {
    // A narrated reading keeps the page on the cards; ReadingHalo frames
    // them under the voice circle instead
    if (phase === 'reading' && willNarrate()) return undefined;

    const timer = setTimeout(() => {
      const step = steps[phase]?.current;
      if (!step) return;
      const { top, bottom } = step.getBoundingClientRect();
      if (phase === 'reveal') {
        // The cards and the buttons under them, all of it when it fits
        glideIntoView(top, bottom, { duration: 1100 });
      } else {
        glideToTop(top);
      }
    }, phase === 'reveal' ? LAST_PICK_MS : SETTLE_MS);
    return () => clearTimeout(timer);
    // The refs are stable; only a change of step moves the page
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phase]);
}
